import { useState, useEffect } from 'react';
import { Plus, Settings2, Search, AlertCircle, X } from 'lucide-react';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { useAuthStore } from '@/store/authStore';
import { ScrollArea } from '@/components/ui/scroll-area';
import { motion } from 'framer-motion';

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};

const item = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0 }
};

export default function RecurringSettings() {
  const { user } = useAuthStore();
  const [filter, setFilter] = useState('');

  return (
    <div className="h-full flex flex-col">
      <header className="border-b border-[#2F2F2F]/10 dark:border-[#333840] bg-white/80 dark:bg-[#182438]/80 backdrop-blur-xl backdrop-saturate-150 sticky top-0 z-10">
        <div className="px-4 sm:px-6 py-4">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-[#439476]/10 rounded-xl">
                <Settings2 className="w-5 h-5 text-[#439476]" />
              </div>
              <div>
                <h1 className="text-xl sm:text-2xl font-semibold bg-gradient-to-r from-[#1C1C1C] to-[#383838] dark:from-[#E8E8E8] dark:to-[#CCCCCC] bg-clip-text text-transparent">
                  Recurring Transactions
                </h1>
                <p className="text-sm sm:text-base text-[#A3A3A3]">
                  Manage your recurring transactions and schedules
                </p>
              </div>
            </div>
            <Button
              onClick={() => {
                // TODO: Implement add recurring transaction
              }}
              className="w-full sm:w-auto bg-[#439476] text-white hover:bg-[#387565] shadow-sm h-11 rounded-xl"
            >
              <Plus className="w-4 h-4 mr-2" />
              Add Recurring Transaction
            </Button>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 items-stretch sm:items-center">
            <div className="relative flex-1">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-[#A3A3A3] w-4 h-4" />
              <Input
                placeholder="Search recurring transactions..."
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
                className="pl-9 w-full h-11 rounded-xl border border-[#2F2F2F]/10 bg-white/50 dark:bg-[#1E2B42]/50 dark:border-[#333840] text-[#1C1C1C] dark:text-[#E8E8E8] shadow-sm focus:ring-2 focus:ring-[#439476]"
              />
              {filter && (
                <Button
                  variant="ghost"
                  size="icon"
                  className="absolute right-2 top-1/2 -translate-y-1/2 h-8 w-8 hover:bg-[#439476]/10 text-[#439476] hover:text-[#387565] rounded-lg"
                  onClick={() => setFilter('')}
                >
                  <X className="h-4 w-4" />
                </Button>
              )}
            </div>
          </div>
        </div>
      </header>

      <ScrollArea className="flex-1 p-4 sm:p-6">
        <motion.div 
          className="space-y-4 max-w-[1920px] mx-auto"
          variants={container}
          initial="hidden"
          animate="show"
        >
          <motion.div 
            className="flex flex-col items-center justify-center py-12 sm:py-16 text-center"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
          >
            <div className="rounded-full bg-[#439476]/10 p-3 mb-4">
              <AlertCircle className="w-6 h-6 text-[#439476]" />
            </div>
            <h3 className="text-base sm:text-lg font-medium text-[#1C1C1C] dark:text-[#E8E8E8]">
              No recurring transactions yet
            </h3>
            <p className="text-sm text-[#A3A3A3] mt-1 max-w-md mx-auto">
              Set up recurring transactions to automatically track regular income or expenses.
            </p>
            <Button
              onClick={() => {
                // TODO: Implement add recurring transaction
              }}
              className="mt-6 bg-[#439476] text-white hover:bg-[#387565] shadow-sm h-11 rounded-xl"
            >
              <Plus className="w-4 h-4 mr-2" />
              Create Your First Recurring Transaction
            </Button>
          </motion.div>
        </motion.div>
      </ScrollArea>
    </div>
  );
} 